import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[numberOnly]',
  standalone: true
})
export class NumberOnlyDirective {
  constructor(private el: ElementRef) { }

  @HostListener('input', ['$event'])
  onInputChange(event: InputEvent) {
    const input = event.target as HTMLInputElement;
    const sanitized = input.value.replace(/[^0-9]*/g, '');
    
    // Update value if it contains non-numeric characters
    if (input.value !== sanitized) {
      input.value = sanitized;
      // Create and dispatch new input event
      const newEvent = new Event('input', { bubbles: true });
      input.dispatchEvent(newEvent);
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    if (event.clipboardData) {
      // Get clipboard data and remove non-numeric characters
      const pastedText = event.clipboardData.getData('text/plain');
      const sanitized = pastedText.replace(/[^0-9]*/g, '');
      
      // Prevent default paste
      event.preventDefault();
      
      // Insert sanitized number
      document.execCommand('insertText', false, sanitized);
    }
  }

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    const allowedKeys = [
      'Backspace', 'Delete', 'Tab', 'Enter', 'ArrowLeft', 'ArrowRight',
      'Home', 'End', 'Control', 'v', 'V', 'a', 'A', 'c', 'C', 'x', 'X'
    ];

    // Allow: navigation keys, delete, backspace
    if (allowedKeys.includes(event.key)) {
      // Allow shortcuts like Ctrl+V, Ctrl+A, Ctrl+C, Ctrl+X
      if (['v', 'V', 'a', 'A', 'c', 'C', 'x', 'X'].includes(event.key) && !event.ctrlKey) {
        event.preventDefault();
      }
      return;
    }

    // Allow: numbers
    if (/^\d$/.test(event.key)) {
      return;
    }

    // Prevent other inputs
    event.preventDefault();
  }
}